import { render, staticRenderFns } from "./SiteLayoutPolyKids.vue?vue&type=template&id=cf5fe5ee&"
import script from "./SiteLayoutPolyKids.vue?vue&type=script&lang=js&"
export * from "./SiteLayoutPolyKids.vue?vue&type=script&lang=js&"
import style0 from "@/assets/hometeacher/css/main.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports